/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_DivisionInputs */

const en__field_division = /** @type {(inputs: _Field_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Division`)
};

const de__field_division = /** @type {(inputs: _Field_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institution/Abteilung/Arbeitsbereich`)
};

/**
* | output |
* | --- |
* | "Division" |
*
* @param {_Field_DivisionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_division = /** @type {((inputs?: _Field_DivisionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_DivisionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_division(inputs)
	return de__field_division(inputs)
});